import 'antd/dist/antd.css';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import './assets/global-css/modal-styles.css';
import { AnalyseFinanPage } from './modules/FiscaliteCompta/pages/analyseEtatFinancier';
import { ComptaFinanPage } from './modules/FiscaliteCompta/pages/comptaFinanciere';
import { ComptaObligPage } from './modules/FiscaliteCompta/pages/comptaObligations';
import { EthiqueRegPage } from './modules/FiscaliteCompta/pages/ethiqueReglementation';
import { FiscaliteComptaPage } from './modules/FiscaliteCompta/pages/fiscaCompta';
import { FiscaliteObligPage } from './modules/FiscaliteCompta/pages/fiscaliteObligation';
import { RisqueFinanPage } from './modules/FiscaliteCompta/pages/risqueFinancier';
import { ConversationsPage } from './modules/chat/conversation';
import { CourbesPage } from './modules/courbes/pages/courbes';
import { TheoriePage } from './modules/courbes/pages/theorie';
import { Dashboard } from './modules/dashboard/pages/dashboard';
import { DefinitionPage } from './modules/formation/pages/definitions';
import { FinancierPage } from './modules/formation/pages/financier';
import { InterBancairePage } from './modules/formation/pages/interbancaire';
import { MoranjePage } from './modules/formation/pages/moranje';
import { ObligationPage } from './modules/formation/pages/obligations';
import {
  AddPostForm,
  AddTopicForm,
  Categorie,
  Forum,
  ForumPost,
} from './modules/forum/pages/forum';
import { HomePage } from './modules/homePage';
import { InfoMarchePage } from './modules/infoMarche/pages/infoMarche';
import { LoginPage } from './modules/login';
import { DashboardPage } from './modules/panel/admin/pages/DashboardPage';
import { PackPage } from './modules/panel/admin/pages/PackPage';
import { ReportingPage } from './modules/panel/admin/pages/ReportingPage';
import { ReportingPortefeuillePage } from './modules/panel/admin/pages/ReportingPortefeuillePage';
import { AgencePage } from './modules/panel/admin/pages/agencePage';
import { GestionPasswordPage } from './modules/panel/admin/pages/gestionPasswordPage';
import { GestionUserProfilPage } from './modules/panel/admin/pages/gestionUserProfilPage';
import { MoranjeAdmin } from './modules/panel/admin/pages/moranjeAdmin';
import { ParameterPage } from './modules/panel/admin/pages/parameterPage';
import { PartnerPage } from './modules/panel/admin/pages/partnerPage';
import { UserAgencePage } from './modules/panel/admin/pages/userPage';
import { ClientPage } from './modules/panel/clientele/pages/clientPage';
import { BalanceGeneralPage } from './modules/panel/comptabilite/pages/balancePage';
import { ComptePage } from './modules/panel/comptabilite/pages/comptePage';
import { GrandLivrePage } from './modules/panel/comptabilite/pages/grandLivrePage';
import { EmissionTitrePage } from './modules/panel/emissionTitre/pages/emissionTitrePage';
import { NewTitrePage } from './modules/panel/emissionTitre/pages/newTitrePage';
import { AdminKycPage } from './modules/panel/kyc/adminKyc';
import { ProfilKycPage } from './modules/panel/kyc/profiluser';
import { RegistrationPage } from './modules/registration';
import { ActivateAccount } from './modules/registration/activateAcount';
import { SuccessActivateAccount } from './modules/registration/successActivateAccount';
import { RegRegionPage } from './modules/reglementation/pages/regRegion';
import { BoursePage } from './modules/reseau/pages/bourses';
import { PageNotFound } from './modules/shared/PageNotFound';
import { SecureRoute } from './modules/shared/ProtectedRoutes';
import { Unauthorized } from './modules/shared/Unauthorized';

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path='/' component={HomePage} />
        {/* <Route exact path='/'>
          <Redirect to='/dashboard' />
        </Route> */}
        <Route exact path='/signin' component={LoginPage} />
        <Route exact path='/signup' component={RegistrationPage} />
        <Route exact path='/activate-account/:userId' component={ActivateAccount} />
        <Route
          exact
          path='/success-activate-account'
          component={SuccessActivateAccount}
        />
        <Route exact path='/unauthorized' component={Unauthorized} />
        <Route exact path='/page-not-found' component={PageNotFound} />
        <Route exact path='/formation' component={InfoMarchePage} />
        <Route exact path='/forum' component={Forum} />
        <Route exact path='/forum-categorie/:catId' component={Categorie} />
        <Route exact path='/forum-post/:postId' component={ForumPost} />
        <Route exact path='/formation-definitions' component={DefinitionPage} />
        <Route
          exact
          path='/formation-marche-financier'
          component={FinancierPage}
        />
        <Route exact path='/formation-obligations' component={ObligationPage} />
        <Route exact path='/formation-moranjetrade' component={MoranjePage} />
        <Route
          exact
          path='/formation-marche-interbancaire'
          component={InterBancairePage}
        />
        <Route
          exact
          path='/fiscalite-comptabilite'
          component={FiscaliteComptaPage}
        />
        <Route
          exact
          path='/fiscalite-comptabilite-comptabilite-financiere'
          component={ComptaFinanPage}
        />
        <Route
          exact
          path='/fiscalite-comptabilite-fiscalite-obligation'
          component={FiscaliteObligPage}
        />
        <Route
          exact
          path='/fiscalite-comptabilite-analyse-etats'
          component={AnalyseFinanPage}
        />
        <Route
          exact
          path='/fiscalite-comptabilite-risque-financiers'
          component={RisqueFinanPage}
        />
        <Route
          exact
          path='/fiscalite-comptabilite-ethique-reglementation'
          component={EthiqueRegPage}
        />
        <Route
          exact
          path='/fiscalite-comptabilite-comptabilite-obligation'
          component={ComptaObligPage}
        />
        <Route exact path='/courbe-theorie' component={TheoriePage} />
        <Route exact path='/courbe-graphe' component={CourbesPage} />
        <Route exact path='/network-bourse' component={BoursePage} />
        <Route exact path='/reglementation' component={RegRegionPage} />

        <SecureRoute
          exact
          path='/dashboard'
          component={Dashboard}
          authorization={[
            'resp_commercial',
            'commercial',
            'chef_agence',
            'gestionnaire',
          ]}
        />
        <SecureRoute exact path='/forum/poster' component={AddTopicForm} />
        <SecureRoute
          exact
          path='/forum/add-subject/:topicId'
          component={AddPostForm}
        />
        <SecureRoute
          exact
          path='/conversations'
          component={ConversationsPage}
        />
        <SecureRoute
          exact
          path='/console/client'
          component={MoranjeAdmin}
          authorization={['sadmin']}
        />
        <SecureRoute
          exact
          path='/console/reporting'
          component={DashboardPage}
          authorization={['sadmin']}
        />
        <SecureRoute
          exact
          path='/console/pack'
          component={PackPage}
          authorization={['sadmin']}
        />
        <SecureRoute
          exact
          path='/console/parameter'
          component={ParameterPage}
          authorization={['sadmin']}
        />
        <SecureRoute
          exact
          path='/reporting-portefeuille'
          component={ReportingPortefeuillePage}
        />
        <SecureRoute exact path='/reporting-titre' component={ReportingPage} />
        <SecureRoute
          exact
          path='/panel/admin/partenaire'
          component={PartnerPage}
          authorization={['admin']}
        />
        <SecureRoute
          exact
          path='/panel/admin/agence'
          component={AgencePage}
          authorization={['admin']}
        />
        <SecureRoute
          exact
          path='/panel/admin/agence-users'
          component={UserAgencePage}
          authorization={['admin']}
        />
        <SecureRoute
          exact
          path='/panel/admin/gestion-utilisateur-profil'
          component={GestionUserProfilPage}
          authorization={['admin']}
        />
        <SecureRoute
          exact
          path='/panel/admin/gestion-mdp'
          component={GestionPasswordPage}
          authorization={['admin']}
        />

        <SecureRoute
          exact
          path='/panel/emission-titre'
          component={EmissionTitrePage}
          authorization={['resp_commercial', 'responsable']}
        />
        <SecureRoute
          exact
          path='/panel/emission-titre-new'
          component={NewTitrePage}
          authorization={['resp_commercial', 'responsable']}
        />

        <SecureRoute
          exact
          path='/panel/comptabilite/comptes'
          component={ComptePage}
          authorization={['resp_commercial', 'responsable']}
        />
        <SecureRoute
          exact
          path='/panel/comptabilite/grand-livre'
          component={GrandLivrePage}
          authorization={['resp_commercial', 'responsable']}
        />
        <SecureRoute
          exact
          path='/panel/comptabilite/balance-general'
          component={BalanceGeneralPage}
          authorization={['resp_commercial', 'responsable']}
        />

        <SecureRoute
          exact
          path='/profil/kyc'
          component={ProfilKycPage}
          authorization={['resp_commercial', 'responsable']}
        />

        <SecureRoute
          exact
          path='/panel/gestion-clientele/clients'
          component={ClientPage}
          authorization={[
            'resp_commercial',
            'commercial',
            'chef_agence',
            'gestionnaire',
          ]}
        />

        <SecureRoute
          exact
          path='/panel/kyc/list'
          component={AdminKycPage}
          authorization={[
            'resp_commercial',
            'commercial',
            'chef_agence',
            'gestionnaire',
          ]}
        />

        <Route
          render={() => <Redirect to={{ pathname: '/page-not-found' }} />}
        />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
